import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useChatbot } from '../../contexts/ChatbotContext';
import { useSubscription } from '../../hooks/useSubscription';
import { supabase } from '../../lib/supabase';
import { NewChatbotModal } from './NewChatbotModal';

export function NewChatbotButton() {
  const [showModal, setShowModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();
  const { refetchChatbot } = useChatbot();
  const { subscription } = useSubscription();

  const handleCreateChatbot = async (name: string, description?: string) => {
    if (!user) return;
    
    try {
      setIsCreating(true);
      setError(null);
      
      const { data: newChatbot, error: createError } = await supabase
        .rpc('create_chatbot', {
          p_name: name,
          p_description: description
        });
      
      if (createError) throw createError;
      
      // Refresh the chatbot list
      await refetchChatbot();
      setShowModal(false);
    } catch (err) {
      console.error('Error creating chatbot:', err);
      setError(err instanceof Error ? err.message : 'Failed to create chatbot');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-violet-500 to-blue-400 text-white hover:opacity-90 transition-opacity"
      >
        <Plus className="w-5 h-5" />
        <span>New chatbot</span>
      </button>

      {showModal && (
        <NewChatbotModal
          onClose={() => setShowModal(false)}
          onCreate={handleCreateChatbot}
          isCreating={isCreating}
          error={error}
          subscription={subscription}
        />
      )}
    </>
  );
} 